import React from "react";
import HseThresholdMetric from "./HseThresholdMetric";
import { Error, Loader } from "./common";
import { overviewChartPalette } from "styles/theme";

const IncidentClosureRateAgeing = ({ incidentClosureRate, isLoading, isError }) => {
    if (isLoading) return <Loader isLoading={isLoading} />;
    if (isError) return <Error isError={isError} />;
    const value = Number(incidentClosureRate) || 0;
    const onTrack = value >= 95;
    const color = onTrack ? overviewChartPalette.teal : overviewChartPalette.coral;
    return <HseThresholdMetric eyebrow="Corrective action" title="Incident Closure Rate" subtitle="Measures timely closure of reported safety incidents." value={value} unit="%" status={onTrack ? "On track" : "Attention"} color={color} progress={value} benchmark="Target 100% · minimum acceptable 95%" />;
};

export default IncidentClosureRateAgeing;
